import ProgressHeader from '../Components/Styled/ProgressHeader';
import { Col, Row } from 'antd';
import { Fragment, useEffect } from 'react';
import FAQSection from '../Components/FAQSection';
import { MEETING_SUCCESS_FAQ } from '../constants';
import { Typography, Timeline } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;
const MeetingScheduled = () => {
  useEffect(() => {
    window.fbq('track', 'Schedule');
    window.sessionStorage.clear();
  }, []);
  return (
    <Fragment>
      <Row type="flex" justify="center">
        <ProgressHeader hasNav={true} showBackIcon={false} />
        <Col xs={0} md={5} lg={6}></Col>
        <Col
          xs={24}
          md={14}
          lg={12}
          style={{ marginTop: '16px' }}
          className="padMobile"
        >
          <Fragment>
            <div>
              <Typography>
                <Title level={2} style={{ textAlign: 'center' }}>
                  Thanks! We're all set to meet
                </Title>

                <Title level={3}>We've reserved your appointment</Title>
                <Timeline
                  style={{ marginBottom: 0 }}
                  items={[
                    {
                      children: (
                        <>
                          <Paragraph>
                            You should receive a text and email confirmation
                            with the appointment details. We look forward to
                            meeting you soon.
                          </Paragraph>
                        </>
                      ),
                      dot: (
                        <CalendarOutlined
                          style={{
                            fontSize: '16px',
                            color: 'green',
                            backgroundColor: 'transparent',
                          }}
                        />
                      ),
                      color: 'blue',
                    },
                  ]}
                />

                <Title level={3} style={{ marginTop: -24 }}>
                  Call or Text Us
                </Title>
                <Paragraph>
                  You can reach us directly via phone or text at{' '}
                  <a href="tel:+14044953864">404-495-3864</a>
                </Paragraph>
              </Typography>
            </div>
          </Fragment>
        </Col>
        <Col xs={0} md={5} lg={6}></Col>
        <Col xs={0} md={5} lg={6}></Col>
      </Row>

      <FAQSection data={MEETING_SUCCESS_FAQ} />
    </Fragment>
  );
};

export default MeetingScheduled;
